import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
`;
export const ButtonAlterarEstadoCheckbox = styled.button.attrs({
  type: 'button',
})`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: none;
  border: none;
  ${({ theme }) => {
    return css`
      gap: ${theme.spacing[3]}px;
    `;
  }}
`;
